import Api from '@/services/api';

class InvoicePdfApi {
    getInvoicePdf(documentType: string, encryptionValue: string, encryptionSalt: string, onSuccess: (pdf: string) => void) {
        return Api.callApi({ url: `/api/v1/invoice/pdf?docType=${documentType}&value=${encryptionValue}&salt=${encryptionSalt}`, onSuccess });
    }
}

export default new InvoicePdfApi();